module.exports = __webpack_public_path__ + "img/logo-beta-white.7a628ef1.svg";